import { render, staticRenderFns } from "./bidInfo.vue?vue&type=template&id=2f178eae&"
import script from "./bidInfo.vue?vue&type=script&lang=js&"
export * from "./bidInfo.vue?vue&type=script&lang=js&"
import style0 from "./bidInfo.vue?vue&type=style&index=0&id=2f178eae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports